import header from '../modules/header/index';
import NewsletterAction from '../modules/newsletterAction';

import "../../../scss/pages/allStyles.scss";

jQuery(function() {
  header();
  
  $('.subscription').on('click', function() {
    NewsletterAction($(this));
  });
})